import * as React from 'react'
import './styles.scss'

export interface ISearchRootProps extends React.ComponentPropsWithoutRef<'input'> {
  children: React.ReactNode
}

export const SearchRoot = ({ children }: ISearchRootProps) => (
  <div className="search-component">{children}</div>
)
